<!-- Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved. -->
<div *ngrxLet="totalEndpoints$ as totalEndpoints" class="endpoints-total-wrapper stats-component">
  <app-display-total-value
    title="{{'endpoints-total.title' | translate}}"
    [total]="totalEndpoints?.totalDevices"
    [loading]="loading$ | async">
  </app-display-total-value>

  <app-display-relative-changes
    [loading]="loading$ | async"
    [amountChanged]="totalEndpoints?.amountChanged"
    [relativeChange]="totalEndpoints?.relativeChange">
  </app-display-relative-changes>
</div>